"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffsetBox = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _Portal = require("../Portal");
var _OffsetBox = require("./OffsetBox.styles");
var _jsxRuntime = require("react/jsx-runtime");
var OffsetBox = function OffsetBox(props) {
  var anchor = props.anchor,
    children = props.children,
    isOpen = props.isOpen,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    _props$isAttachedToWi = props.isAttachedToWindow,
    isAttachedToWindow = _props$isAttachedToWi === void 0 ? false : _props$isAttachedToWi,
    _props$isCenteredToAn = props.isCenteredToAnchor,
    isCenteredToAnchor = _props$isCenteredToAn === void 0 ? false : _props$isCenteredToAn,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 5 : _props$offset,
    id = props.id,
    _props$anchorWidth = props.anchorWidth,
    anchorWidth = _props$anchorWidth === void 0 ? 'fit-content' : _props$anchorWidth,
    onBoxPositionChange = props.onBoxPositionChange;
  var anchorRef = (0, _react.useRef)(null);
  var boxRef = (0, _react.useRef)(null);
  var styles = (0, _OffsetBox.useStyles)({
    position: position,
    isAttachedToWindow: isAttachedToWindow,
    isCenteredToAnchor: isCenteredToAnchor,
    offset: offset,
    isOpen: isOpen,
    anchorWidth: anchorWidth,
    anchorRef: anchorRef,
    boxRef: boxRef
  });
  (0, _react.useEffect)(function () {
    if (isOpen && onBoxPositionChange && styles.currentBoxPosition) {
      onBoxPositionChange(styles.currentBoxPosition);
    }
  }, [isOpen, onBoxPositionChange, styles.currentBoxPosition]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": id ? "anchor-".concat(id) : null,
      className: styles['cc-OffsetBox__anchor'],
      ref: anchorRef,
      children: anchor
    }), isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-testid": id ? "box-".concat(id) : null,
        ref: boxRef,
        className: (0, _css.css)(styles['cc-OffsetBox__box']),
        children: children
      })
    })]
  });
};
exports.OffsetBox = OffsetBox;